import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkerLaboratoryGrade = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M48 48H0V0h48zM12 9v30h24v-7.886H22.047V9z" })
});
export default SvgMarkerLaboratoryGrade;
